<template>
  <div>
    <a-pagination
      size="small"
      show-size-changer
      show-quick-jumper
      :current="pageNum"
      :pageSize="pageSize"
      :total="total"
      :pageSizeOptions="pageSizeOptions"
      @change="changePage"
      @showSizeChange="onShowSizeChange"
      :show-total="total => `总共 ${total} 个记录`"
      class="tar"
    />
  </div>
</template>
<script>
import { defineComponent, inject, toRefs } from 'vue'
export default defineComponent({
  setup() {
    const state = inject('state')
    return {
      pageSizeOptions: ['10', '20', '50', '100', '200'],
      ...toRefs(state)
    }
  }
})
</script>
